import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFederalBankHolidayCibc = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "12.15 46.63 318.76 163.97",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#CCDDF2",
			fillRule: "evenodd",
			d: "M264.093 147.855c12.021 0 21.841 9.407 22.508 21.261a16.69 16.69 0 0 1 11.562-4.637c9.251 0 16.749 7.499 16.749 16.75 0 8.273-5.999 15.389-13.882 16.75h-62.402c-6.273 0-11.357-5.085-11.357-11.358 0-6.272 5.084-11.357 11.357-11.357 1.253 0 2.457.206 3.585.58a22.595 22.595 0 0 1-.666-5.443c0-12.452 10.094-22.546 22.546-22.546ZM96.186 132.749c14.685 0 26.627 11.703 27.033 26.289a20.468 20.468 0 0 1 9.238-2.192c11.358 0 20.566 9.207 20.566 20.566 0 11.359-9.208 20.567-20.566 20.567H42.195c-7.757 0-14.045-6.288-14.045-14.045 0-7.756 6.288-14.044 14.045-14.044 1.397 0 2.745.207 4.019.587a17.686 17.686 0 0 1-1.042-5.996c0-9.788 7.934-17.724 17.724-17.724 3.087 0 5.988.791 8.516 2.179 4.185-9.529 13.7-16.187 24.774-16.187Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C41F3E",
			fillRule: "evenodd",
			d: "M88.498 200.6H254.42v-91.004H88.498V200.6Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8B1D41",
			fillRule: "evenodd",
			d: "M240.849 200.6H199.64v-52.205c0-11.379 9.225-20.604 20.605-20.604 11.379 0 20.604 9.225 20.604 20.604V200.6Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			d: "M230.552 174.045a3.37 3.37 0 1 1 6.74 0 3.37 3.37 0 0 1-6.74 0ZM220.245 143.744l7.742 8.202h-15.485l7.743-8.202Zm8.933 8.202-8.933-9.464-8.934 9.464h-2.109v12.501l22.085-12.501h-2.109Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F2F3F2",
			fillRule: "evenodd",
			d: "M231.287 151.946v12.501h-22.085l22.085-12.501Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8B1D41",
			fillRule: "evenodd",
			d: "m262.739 104.406-8.319-21.649V56.631H88.498v26.126l-8.32 21.649c-.96 2.502.886 5.19 3.566 5.19h175.43c2.68 0 4.527-2.688 3.565-5.19Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "a",
			width: 287,
			height: 145,
			x: 28,
			y: 56,
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M28.15 200.6h286.763V56.631H28.15V200.6Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			mask: "url(#a)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M102.308 178.084h82.339v-50.293h-82.339v50.293Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#F2F3F2",
					d: "M184.647 127.791v50.292h-82.339l82.339-50.292Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#C41F3E",
					d: "M218.904 143.452a1.34 1.34 0 1 1 2.681-.001 1.34 1.34 0 0 1-2.681.001ZM106.934 82.757h18.436V56.631h-18.436v26.126ZM143.805 82.757h18.436V56.631h-18.436v26.126ZM180.677 82.757h18.436V56.631h-18.436v26.126ZM217.549 82.757h18.435V56.631h-18.435v26.126Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M254.419 110.895H88.496l.004-1.299h165.922l-.003 1.299Z"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgFederalBankHolidayCibc);
export { ForwardRef as ReactComponent };
